<template>
    <div class="courseModule">
        <slot></slot>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    }
}
</script>

<style lang="less" scoped>
.courseModule{
    margin-top: 20px;
}
</style>
